export enum StatisticReportSourceType {
    BRIEFING = 'BRIEFING',
    DISTRIBUTION = 'DISTRIBUTION'
};
